import { useTranslation } from 'react-i18next'
import NextLink from 'next/link'
import { useRouter } from 'next/router'
import { Button } from 'settle-ui/components/Button/Button'
import { logEvent } from 'lib/tracking/segment'
import { getURLSearch } from 'lib/navigation/helpers/getURLSearch/getURLSearch'
import { getPayerSignUpPath } from 'lib/navigation/helpers/getPayerSignUpPath/getPayerSignUpPath'
import * as events from '../../LoginPage.events'

export const CreateAccountButton = () => {
  const { t } = useTranslation()
  const router = useRouter()
  const handleClick = () => logEvent(events.CREATE_ACCOUNT_LINK_CLICK)
  const href = getPayerSignUpPath('product', { search: getURLSearch(router.query) })

  return (
    <Button component={NextLink} variant="secondary" fullWidth={true} onClick={handleClick} href={href}>
      {t('loginPage::createAccountButton')}
    </Button>
  )
}
